// extracted by mini-css-extract-plugin
export default {"container":"Xr1UdSNhvYhnj3kSliS5","purchaseBtn":"UXPA7A8GiNYOaPTW1YLp","priceInfo":"FYgxxDrvT0WNNM9G8jCA"};